import { DBCollection } from '@/lib/utils/constants-shared';
import type { Firestore } from 'firebase/firestore';
import { collection, getDocs } from 'firebase/firestore';

import { fetchCollectionFromStorage } from '@/lib/utils/storage-bulk-data';
import type { FirebaseStorage } from 'firebase/storage';

/**
 * Fetch people by passage from DB (Storage first, then Firestore)
 */
export async function fetchPeopleByPassageFromDB(
  auth: any,
  db: Firestore,
  storage?: FirebaseStorage
): Promise<PeopleByPassage[]> {
  const fallback = async () => {
    const peopleByPassageRef = collection(db, DBCollection.peopleByPassage);
    const snapshot = await getDocs(peopleByPassageRef);

    return snapshot.docs.map(doc => ({
      id: doc.id,
      passageId: doc.id, // Document ID is the passage ID
      ...doc.data(),
      dateCreated: doc.data().dateCreated?.toDate(),
      dateUpdated: doc.data().dateUpdated?.toDate()
    })) as PeopleByPassage[];
  };

  if (storage) {
    return await fetchCollectionFromStorage<PeopleByPassage>(
      storage,
      `bulk-data/${DBCollection.peopleByPassage}.json`,
      fallback
    );
  }

  return await fallback();
}

